// extracted by mini-css-extract-plugin
export default {"circle":"chartCircle_circle__1FN5M","text":"chartCircle_text__JpwhL"};